import React from 'react';
import { RotateCcw } from 'lucide-react';

/**
 * RevertVersionModal — extracted from RFPAnalysisResult.jsx (Phase 1 refactor).
 * Zero logic changes. All state/handlers passed as props from parent.
 */
const RevertVersionModal = ({
    show,
    onClose,
    revertTargetVersion,
    revertReason,
    setRevertReason,
    handleRevertVersion,
    stripPrefix,
    activeSection
}) => {
    if (!show) return null;

    return (
        <div className="custom-modal-overlay" style={{ zIndex: 10001 }}>
            <div className="stage-modal-content" style={{ maxWidth: '420px', padding: '1.25rem' }}>
                <div className="stage-modal-header" style={{ textAlign: 'center', marginBottom: '1rem' }}>
                    <div style={{
                        background: '#FFF1EC',
                        color: '#FF5526',
                        width: '40px',
                        height: '40px',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 0.75rem auto'
                    }}>
                        <RotateCcw size={20} />
                    </div>
                    <h3 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#1E293B', marginBottom: '0.25rem' }}>
                        Revert to Version {revertTargetVersion?.version_number || revertTargetVersion?.id}
                    </h3>
                    <p style={{ color: '#64748B', fontSize: '0.85rem', lineHeight: '1.4' }}>
                        You are about to restore <strong>{stripPrefix(activeSection)}</strong> to its state in <strong>Version {revertTargetVersion?.version_number || revertTargetVersion?.id}</strong>.
                    </p>
                </div>

                <div style={{
                    background: '#FFFBEB',
                    border: '1px solid #FEF3C7',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    marginBottom: '1rem',
                    color: '#92400E',
                    fontSize: '0.8rem',
                    textAlign: 'center'
                }}>
                    This will create a new version with the restored content.
                </div>

                <div className="stage-modal-body" style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', fontSize: '0.7rem', fontWeight: '700', color: '#64748B', textTransform: 'uppercase', marginBottom: '0.4rem' }}>
                        Reason for restoration
                    </label>
                    <textarea
                        className="stage-modal-notes"
                        style={{ minHeight: '60px', padding: '0.6rem', fontSize: '0.85rem' }}
                        value={revertReason}
                        onChange={(e) => setRevertReason(e.target.value)}
                        placeholder="Restoring to previous draft"
                    />
                </div>

                <div className="stage-modal-actions" style={{ display: 'flex', gap: '0.75rem' }}>
                    <button
                        className="stage-modal-cancel"
                        style={{ flex: 1, padding: '0.6rem', background: 'white', border: '1px solid #E2E8F0', borderRadius: '8px', color: '#64748B', fontWeight: '600', fontSize: '0.85rem' }}
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="stage-modal-confirm"
                        style={{ flex: 1, padding: '0.6rem', background: '#FF5526', border: 'none', borderRadius: '8px', color: 'white', fontWeight: '600', fontSize: '0.85rem' }}
                        onClick={handleRevertVersion}
                    >
                        Restore Version
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RevertVersionModal;
